<template>
  <div class="page home-page">
    <div class="home-layout">
      <div class="image-ripples">
        <img
          src="../assets/female.png"
          alt="female"
          v-if="thisUser.details.gender === 'female'"
        />
        <img src="../assets/male.png" alt="male" v-else />
        <div v-if="chatSearching"></div>
      </div>
      <button v-if="!chatSearching && readyToMatch" @click="matchUser(true)">
        <span>{{ appVocubulary.newChat }}</span>
        <!-- <span>
          <i class="fas fa-circle-notch fa-spin"></i>
          {{ appVocubulary.connecting }}</span
        > -->
      </button>
      <div class="ad-space" v-if="!chatSearching">
        <a href="https://www.facebook.com/Moneerprofacc/" target="_blank">
          <img src="../assets/my-ad.jpg" alt="ad" />
        </a>
      </div>
      <button
        class="stop-searching"
        @click="matchUser(false)"
        v-if="chatSearching"
      >
        <i class="fas fa-times fa-2x"></i>
      </button>
      <div v-if="chatSearching" class="hints">
        <i class="fas fa-circle"></i>
        <span>{{ connected }} {{ appVocubulary.peopleRConnected }}</span>
        <br />
        <span class="tip">{{ appVocubulary.tip1 }}</span>
      </div>
    </div>
    <transition name="opacity">
      <w-popup ref="popup" />
    </transition>
  </div>
</template>

<script>
import WPopup from "../components/WPopup.vue";

export default {
  name: "Home",
  data() {
    return {
      chatSearching: false,
      message: "",
    };
  },
  components: { WPopup },
  computed: {
    socket() {
      return this.$store.state.socket;
    },
    thisUser() {
      return this.$store.state.user;
    },
    readyToMatch() {
      return this.thisUser.socketId;
    },
    thePartner() {
      return this.$store.state.partner;
    },
    connected() {
      return this.$store.state.connected;
    },
    lang() {
      return this.$store.state.lang;
    },
    appVocubulary() {
      return this.$store.state.appVocubulary[this.lang].pages.Home;
    },
  },
  watch: {
    thePartner(newPartner) {
      if (newPartner.socketId) {
        document.getElementById("chat-link").click();
      }
    },
  },
  methods: {
    matchUser(decision) {
      if (this.readyToMatch) {
        this.chatSearching = decision;
        if (decision) {
          // if the user is searching emit the matchThisOne event to server with this user data
          this.socket.emit("matchThisOne", this.thisUser);
        } else {
          this.socket.emit("leaveRoom", {
            roomId: this.thisUser.room,
            isPartner: false,
          });
          this.$store.commit("updatePartner", { name: "" });
        }
      }
      // set the searching state and connect to socket io
    },
    async showPopup(options) {
      const confirmationResult = await this.$refs.popup.show(options);
      if (confirmationResult) {
        location.reload();
      }
    },
  },
  beforeMount() {
    if (!this.thisUser.socketId && this.thisUser.name) {
      console.log("connect");
      this.socket.connect();
    }
    if (this.thisUser.name === "") {
      document.getElementById("login-link").click();
    }
    // reset partner when you are in home screen
    this.$store.commit("updatePartner", {
      name: "",
      age: 0,
      details: { gender: "", country: "" },
    });

    this.$store.commit("updateUserWith", { updatedProp: "room", newValue: "" });
    this.$store.commit("updateUserWith", {
      updatedProp: "room_name",
      newValue: "",
    });
  },
  mounted() {
    // Socket.io Home Handelers :

    // 1) get the number of connected users :
    this.socket.on("sendConnected", (peopleConnected) => {
      this.$store.commit("setConnectedUsers", peopleConnected);
    });

    // 2) set this user's id when the socket connects to server :
    this.socket.on("updateId", (socketId) => {
      this.$store.commit("updateUserWith", {
        updatedProp: "socketId",
        newValue: socketId,
      });
    });

    // 3) set this user's room when it's set from the server :
    this.socket.on("updateRoom", (roomId) => {
      this.$store.commit("updateUserWith", {
        updatedProp: "room",
        newValue: roomId,
      });
    });

    // 4) set the new partner when the user matches :
    this.socket.on("updatePartner", ({ user1, user2 }) => {
      if (user1.socketId !== this.thisUser.socketId) {
        [user1, user2] = [user2, user1];
      }
      this.$store.commit("updatePartner", user2);
    });
  },
  unmounted() {
    // necessary proccess so the one event doesn't register a listener everytime the home component is mounted
    this.socket.removeAllListeners("sendConnected");
    this.socket.removeAllListeners("updateId");
    this.socket.removeAllListeners("updateRoom");
    this.socket.removeAllListeners("updatePartner");
  },
};
</script>

<style lang="scss" scoped>
.home-page {
  .home-layout {
    height: calc(100%);
    display: grid;
    padding: 10px;
    justify-items: center;
    align-items: center;

    .hints {
      max-width: 80%;
      text-align: center;
      span,
      i {
        color: green;
        margin: 0 10px;
        font-size: 0.96em;
      }
      i {
        transform: scale(0.6);
      }
      .tip {
        display: inline-block;
        color: var(--accent);
        font-size: 0.9em;
        margin: 10px 0;
      }
    }

    .ad-space {
      position: relative;
      align-self: end;
      width: 100%;
      height: 120px;
      border: 2px dashed var(--accent);
      background-color: rgba(103, 55, 216, 0.16);
      color: var(--accent);
      font-weight: bold;
      justify-content: center;
      align-items: center;
      display: flex;
      padding: 2px;
      max-width: 400px;
      a {
        height: 100%;
        width: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
        }
      }
      &:before {
        content: "Ad space";
        position: absolute;
        top: 0;
        transform: translateY(-100%);
        left: 10px;
        font-weight: bold;
        font-size: 0.7em;
        background: var(--accent);
        color: white;
        padding: 6px;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
      }
    }

    button {
      width: 60%;
      max-width: 300px;
      padding: 20px;
      border-radius: 40px;
      background-color: var(--accent);
      color: white;
    }

    .stop-searching {
      width: 80px;
      background-color: rgba(0, 0, 0, 0.4);
      color: white;
    }

    .image-ripples {
      position: relative;
      width: 60%;
      margin: 0 15%;
      max-width: 240px;

      img {
        width: 100%;
        z-index: 1;
      }

      div {
        z-index: -1;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: var(--accent);
        opacity: 0.7;
        animation: ripples 0.8s infinite linear;
      }
    }
  }
}

@keyframes ripples {
  0% {
    opacity: 0.7;
  }
  100% {
    transform: scale(1.4);
    opacity: 0;
  }
}
</style>
